
{
  "familyId": "STU-GRAFIEK",
  "questions": [
    {
      "id": "STU-GRAFIEK-001",
      "familyId": "STU-GRAFIEK",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_grafiek",
      "questionType": "bar_chart",
      "question": "Een meteoroloog bekijkt de regenval. In welke maand regende het het meest? Klik op de juiste staaf.",
      "options": ["Maart", "Juli", "September", "November"],
      "correctAnswer": 3,
      "data": {
        "data": [
          { "label": "Maart", "value": 45 },
          { "label": "Juli", "value": 60 },
          { "label": "September", "value": 55 },
          { "label": "November", "value": 80 }
        ],
        "correctIndex": 3,
        "xAxisLabel": "Maand",
        "yAxisLabel": "Regenval (mm)",
        "hideValues": true
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Staafgrafiek lezen",
            "content": "Kijk naar de hoogte van elke staaf. De hoogste staaf heeft de grootste waarde. November heeft de hoogste staaf (80 mm).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bar_chart_reading",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De meteoroloog vergelijkt de hoogte van alle staven en zoekt de hoogste. Maart = 45 mm, Juli = 60 mm, September = 55 mm, November = 80 mm. De hoogste staaf is November (80 mm) — in november regende het het meest.",
        "solutionSteps": [
          "Lees de waarde van elke staaf af: Maart = 45, Juli = 60, September = 55, November = 80",
          "Vergelijk de waarden en zoek de hoogste: 80 mm (November)"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat maart de meeste regen had. Maar maart had 45 mm regen — dat is juist het minst van alle maanden. Onthoud: de laagste staaf = het minst.",
          "1": "Je dacht waarschijnlijk dat juli de meeste regen had. Maar juli had 60 mm — veel, maar niet het meest. November had 80 mm, dat is 20 mm meer. Onthoud: vergelijk altijd alle staven.",
          "2": "Je dacht waarschijnlijk dat september het meest was. Maar september had 55 mm, terwijl november 80 mm had. Onthoud: vergelijk alle staven voordat je kiest.",
          "3": "Goed! In november regende het het meest (80 mm)."
        }
      }
    },
    {
      "id": "STU-GRAFIEK-002",
      "familyId": "STU-GRAFIEK",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_grafiek",
      "questionType": "multiple_choice",
      "question": "Een bibliothecaris houdt bij hoeveel boeken Emma leest. Hoeveel boeken las ze in totaal?",
      "options": ["18", "6", "5", "7"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "barChart",
          "data": {
            "data": [
              { "label": "Q1", "value": 6 },
              { "label": "Q2", "value": 5 },
              { "label": "Q3", "value": 7 }
            ],
            "xAxisLabel": "Kwartaal",
            "yAxisLabel": "Aantal boeken",
            "hideValues": true
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Totaal berekenen uit grafiek",
            "content": "Om het totaal te vinden, tel je alle waarden bij elkaar op: Q1 (6) + Q2 (5) + Q3 (7) = 18 boeken.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bar_chart_calculation",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De bibliothecaris telt alle kwartalen bij elkaar op: Q1 = 6, Q2 = 5, Q3 = 7. Totaal: 6 + 5 + 7 = 18 boeken.",
        "solutionSteps": [
          "Lees de waarde van elke staaf af: Q1 = 6, Q2 = 5, Q3 = 7",
          "Tel alle waarden bij elkaar op: 6 + 5 + 7 = 18 boeken"
        ],
        "distractorExplanations": {
          "0": "Goed! Emma las in totaal 18 boeken (6 + 5 + 7 = 18).",
          "1": "Je dacht waarschijnlijk dat je maar één staaf hoeft af te lezen. Maar 6 is alleen het aantal boeken in Q1. Bij 'in totaal' moet je alle kwartalen optellen: 6 + 5 + 7 = 18. Onthoud: 'totaal' = alles bij elkaar optellen.",
          "2": "Je dacht waarschijnlijk dat je maar één staaf hoeft af te lezen. Maar 5 is alleen het aantal boeken in Q2. Bij 'in totaal' tel je alles op: 6 + 5 + 7 = 18. Onthoud: 'totaal' = alles bij elkaar optellen.",
          "3": "Je dacht waarschijnlijk dat je maar één staaf hoeft af te lezen. Maar 7 is alleen het aantal boeken in Q3. Bij 'in totaal' tel je alles op: 6 + 5 + 7 = 18. Onthoud: 'totaal' = alles bij elkaar optellen."
        }
      }
    },
    {
      "id": "STU-GRAFIEK-003",
      "familyId": "STU-GRAFIEK",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_grafiek",
      "questionType": "bar_chart",
      "question": "Een sportcoach bekijkt de favoriete sporten. Welke sport is het populairst? Klik op de juiste staaf.",
      "options": ["Voetbal", "Tennis", "Zwemmen", "Hockey"],
      "correctAnswer": 0,
      "data": {
        "data": [
          { "label": "Voetbal", "value": 12 },
          { "label": "Tennis", "value": 4 },
          { "label": "Zwemmen", "value": 8 },
          { "label": "Hockey", "value": 6 }
        ],
        "correctIndex": 0,
        "xAxisLabel": "Sport",
        "yAxisLabel": "Aantal leerlingen",
        "hideValues": true
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoogste staaf vinden",
            "content": "Vergelijk de hoogte van alle staven. De hoogste staaf = de populairste sport. Voetbal (12) is de hoogste staaf.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bar_chart_interactive_max",
      "variantIndex": 3,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "De sportcoach vergelijkt de hoogte van alle staven. Voetbal = 12, tennis = 4, zwemmen = 8, hockey = 6. De hoogste staaf is voetbal (12 leerlingen) — voetbal is het populairst.",
        "solutionSteps": [
          "Lees de waarde van elke staaf af: voetbal=12, tennis=4, zwemmen=8, hockey=6",
          "Vergelijk de waarden en zoek de hoogste: 12 (voetbal)"
        ],
        "distractorExplanations": {
          "0": "Goed! Voetbal is het populairst met 12 leerlingen.",
          "1": "Je dacht waarschijnlijk dat tennis het populairst is. Maar tennis had 4 leerlingen — dat is juist het minst. Onthoud: de hoogste staaf = het meest populair.",
          "2": "Je dacht waarschijnlijk dat zwemmen het populairst is. Maar zwemmen had 8 leerlingen, terwijl voetbal 12 had. Onthoud: vergelijk altijd alle staven.",
          "3": "Je dacht waarschijnlijk dat hockey het populairst is. Maar hockey had 6 leerlingen, terwijl voetbal 12 had. Onthoud: vergelijk alle staven."
        }
      }
    },
    {
      "id": "STU-GRAFIEK-004",
      "familyId": "STU-GRAFIEK",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_grafiek",
      "questionType": "bar_chart",
      "question": "Een klimatoloog bekijkt de temperatuurgegevens. In welke maand was het het warmst? Klik op de juiste staaf.",
      "options": ["Januari", "April", "Juli", "Oktober"],
      "correctAnswer": 2,
      "data": {
        "data": [
          { "label": "Januari", "value": 3 },
          { "label": "April", "value": 10 },
          { "label": "Juli", "value": 20 },
          { "label": "Oktober", "value": 11 }
        ],
        "correctIndex": 2,
        "xAxisLabel": "Maand",
        "yAxisLabel": "Temperatuur (°C)",
        "hideValues": true
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoogste waarde aflezen",
            "content": "Kijk naar de hoogte van elke staaf. Juli (20°C) is de hoogste staaf — in juli was het het warmst.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bar_chart_interactive_temp",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De klimatoloog vergelijkt de hoogte van alle staven. Januari = 3°C, april = 10°C, juli = 20°C, oktober = 11°C. De hoogste staaf is juli (20°C) — in juli was het het warmst.",
        "solutionSteps": [
          "Lees alle waarden af: jan=3, apr=10, jul=20, okt=11",
          "Vergelijk de waarden en zoek de hoogste: 20°C (juli)"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat januari het warmst was. Maar januari had 3°C — dat is juist het koudst. Onthoud: de hoogste staaf = het warmst.",
          "1": "Je dacht waarschijnlijk dat april het warmst was. Maar april had 10°C, terwijl juli 20°C had. Onthoud: vergelijk altijd alle staven.",
          "2": "Goed! In juli was het het warmst (20°C).",
          "3": "Je dacht waarschijnlijk dat oktober het warmst was. Maar oktober had 11°C, terwijl juli 20°C had. Onthoud: vergelijk alle staven."
        }
      }
    },
    {
      "id": "STU-GRAFIEK-005",
      "familyId": "STU-GRAFIEK",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_grafiek",
      "questionType": "multiple_choice",
      "question": "Een schooldirecteur bekijkt de favoriete vakken. Bekijk het staafdiagram. Welke twee vakken zijn samen even populair als wiskunde?",
      "options": ["Engels en tekenen", "Nederlands en tekenen", "Engels en Nederlands", "Gym en tekenen"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "barChart",
          "data": {
            "data": [
              { "label": "Wiskunde", "value": 10 },
              { "label": "Nederlands", "value": 3 },
              { "label": "Engels", "value": 6 },
              { "label": "Tekenen", "value": 4 },
              { "label": "Gym", "value": 8 }
            ],
            "xAxisLabel": "Vak",
            "yAxisLabel": "Aantal leerlingen",
            "hideValues": true
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Combinaties vergelijken",
            "content": "Wiskunde = 10 leerlingen. Zoek twee vakken die samen ook 10 zijn: Engels (6) + tekenen (4) = 10. ✓",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bar_chart_combination",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "De schooldirecteur zoekt twee vakken die samen 10 leerlingen hebben (even veel als wiskunde). Engels (6) + tekenen (4) = 10 ✓. Dat klopt!",
        "solutionSteps": [
          "Lees wiskunde af: 10 leerlingen",
          "Probeer combinaties: Engels (6) + tekenen (4) = 10 ✓",
          "Controleer: 10 = 10, dus Engels en tekenen zijn samen even populair als wiskunde"
        ],
        "distractorExplanations": {
          "0": "Goed! Engels (6) + tekenen (4) = 10, even veel als wiskunde (10).",
          "1": "Je dacht waarschijnlijk dat Nederlands en tekenen samen 10 zijn. Maar Nederlands (3) + tekenen (4) = 7, niet 10. Onthoud: reken altijd na voordat je kiest.",
          "2": "Je dacht waarschijnlijk dat Engels en Nederlands samen 10 zijn. Maar Engels (6) + Nederlands (3) = 9, niet 10. Onthoud: reken altijd na.",
          "3": "Je dacht waarschijnlijk dat gym en tekenen samen 10 zijn. Maar gym (8) + tekenen (4) = 12, dat is meer dan 10. Onthoud: reken altijd na."
        }
      }
    },
    {
      "id": "STU-GRAFIEK-006",
      "familyId": "STU-GRAFIEK",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_grafiek",
      "questionType": "bar_chart",
      "question": "Een tuinman houdt bij hoeveel planten hij per maand verkoopt. In welke maand verkocht hij precies 15 planten? Klik op de juiste staaf.",
      "options": ["Maart", "April", "Mei", "Juni", "Juli"],
      "correctAnswer": 2,
      "data": {
        "data": [
          { "label": "Maart", "value": 10 },
          { "label": "April", "value": 12 },
          { "label": "Mei", "value": 15 },
          { "label": "Juni", "value": 20 },
          { "label": "Juli", "value": 18 }
        ],
        "correctIndex": 2,
        "xAxisLabel": "Maand",
        "yAxisLabel": "Aantal planten",
        "hideValues": true
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tussenwaarden aflezen",
            "content": "Kijk goed naar de y-as. De lijnen staan op 0, 5, 10, 15, 20. Zoek de staaf die precies op de lijn van 15 komt. Mei komt precies op 15.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bar_chart_between_values",
      "variantIndex": 6,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De tuinman zoekt de staaf die precies op 15 komt. Maart = 10, april = 12, mei = 15, juni = 20, juli = 18. Mei komt precies op de lijn van 15 — dat is het juiste antwoord.",
        "solutionSteps": [
          "Zoek de lijn van 15 op de y-as",
          "Kijk welke staaf precies op die lijn komt",
          "Mei = 15 planten ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat maart 15 planten had. Maar maart had 10 planten — de staaf komt tot de lijn van 10. Onthoud: lees de y-as nauwkeurig af.",
          "1": "Je dacht waarschijnlijk dat april 15 planten had. Maar april had 12 planten — de staaf zit tussen 10 en 15. Onthoud: kijk of de staaf precies op een lijn komt.",
          "2": "Goed! Mei had precies 15 planten.",
          "3": "Je dacht waarschijnlijk dat juni 15 planten had. Maar juni had 20 planten — de staaf komt tot de lijn van 20. Onthoud: lees de y-as nauwkeurig af.",
          "4": "Je dacht waarschijnlijk dat juli 15 planten had. Maar juli had 18 planten — de staaf zit tussen 15 en 20. Onthoud: kijk of de staaf precies op een lijn komt."
        }
      }
    },
    {
      "id": "STU-GRAFIEK-007",
      "familyId": "STU-GRAFIEK",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_grafiek",
      "questionType": "bar_chart",
      "question": "Een dierenarts telt de huisdieren die ze deze week behandelde. Welk dier behandelde ze het minst? Klik op de juiste staaf.",
      "options": ["Hond", "Kat", "Konijn", "Hamster", "Vogel"],
      "correctAnswer": 3,
      "data": {
        "data": [
          { "label": "Hond", "value": 8 },
          { "label": "Kat", "value": 6 },
          { "label": "Konijn", "value": 3 },
          { "label": "Hamster", "value": 1 },
          { "label": "Vogel", "value": 4 }
        ],
        "correctIndex": 3,
        "xAxisLabel": "Dier",
        "yAxisLabel": "Aantal behandelingen",
        "hideValues": true
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Laagste staaf vinden",
            "content": "Bij 'het minst' zoek je de laagste staaf. Hond=8, kat=6, konijn=3, hamster=1, vogel=4. Hamster (1) is de laagste staaf.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bar_chart_interactive_min",
      "variantIndex": 7,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De dierenarts zoekt de laagste staaf. Hond = 8, kat = 6, konijn = 3, hamster = 1, vogel = 4. De laagste staaf is hamster (1 behandeling) — de hamster werd het minst behandeld.",
        "solutionSteps": [
          "Lees alle waarden af: hond=8, kat=6, konijn=3, hamster=1, vogel=4",
          "Vergelijk en zoek de laagste: 1 (hamster)"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat de hond het minst was. Maar de hond had 8 behandelingen — dat is juist het meest. Onthoud: de laagste staaf = het minst.",
          "1": "Je dacht waarschijnlijk dat de kat het minst was. Maar de kat had 6 behandelingen. Hamster had er maar 1. Onthoud: vergelijk alle staven.",
          "2": "Je dacht waarschijnlijk dat het konijn het minst was. Maar het konijn had 3 behandelingen, terwijl hamster er maar 1 had. Onthoud: vergelijk alle staven.",
          "3": "Goed! De hamster werd het minst behandeld (1 keer).",
          "4": "Je dacht waarschijnlijk dat de vogel het minst was. Maar de vogel had 4 behandelingen, terwijl hamster er maar 1 had. Onthoud: vergelijk alle staven."
        }
      }
    },
    {
      "id": "STU-GRAFIEK-008",
      "familyId": "STU-GRAFIEK",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_grafiek",
      "questionType": "multiple_choice",
      "question": "Een apotheker houdt bij hoeveel recepten ze per dag verwerkt. Bekijk de lijngrafiek. Op welke dag verwerkte ze de meeste recepten?",
      "options": ["Woensdag", "Maandag", "Dinsdag", "Vrijdag"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "lineChart",
          "data": {
            "data": [
              { "label": "Ma", "value": 30 },
              { "label": "Di", "value": 25 },
              { "label": "Wo", "value": 45 },
              { "label": "Do", "value": 35 },
              { "label": "Vr", "value": 40 }
            ],
            "xAxisLabel": "Dag",
            "yAxisLabel": "Aantal recepten",
            "hideValues": true
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Lijngrafiek lezen",
            "content": "Bij een lijngrafiek kijk je naar het hoogste punt van de lijn. Het hoogste punt is woensdag (45 recepten). Tip: volg de lijn met je vinger en zoek de piek.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "line_chart_reading_max",
      "variantIndex": 8,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De apotheker zoekt het hoogste punt in de lijngrafiek. Maandag = 30, dinsdag = 25, woensdag = 45, donderdag = 35, vrijdag = 40. Het hoogste punt is woensdag (45 recepten) — op woensdag verwerkte ze de meeste recepten.",
        "solutionSteps": [
          "Volg de lijn en zoek het hoogste punt",
          "Lees de waarden af: ma=30, di=25, wo=45, do=35, vr=40",
          "Het hoogste punt is woensdag (45)"
        ],
        "distractorExplanations": {
          "0": "Goed! Woensdag had de meeste recepten (45).",
          "1": "Je dacht waarschijnlijk dat maandag het meest was. Maar maandag had 30 recepten, terwijl woensdag 45 had. Onthoud: zoek het hoogste punt van de lijn.",
          "2": "Je dacht waarschijnlijk dat dinsdag het meest was. Maar dinsdag had 25 recepten — dat is juist het minst. Onthoud: het laagste punt = het minst.",
          "3": "Je dacht waarschijnlijk dat vrijdag het meest was. Maar vrijdag had 40 recepten, terwijl woensdag 45 had. Onthoud: vergelijk alle punten voordat je kiest."
        }
      }
    },
    {
      "id": "STU-GRAFIEK-009",
      "familyId": "STU-GRAFIEK",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_grafiek",
      "questionType": "multiple_choice",
      "question": "Een ecoloog bestudeert de temperatuur van een vijver. Bekijk de lijngrafiek. Tussen welke twee maanden steeg de temperatuur het snelst?",
      "options": ["April → Mei", "Maart → April", "Mei → Juni", "Juni → Juli"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "lineChart",
          "data": {
            "data": [
              { "label": "Mrt", "value": 6 },
              { "label": "Apr", "value": 10 },
              { "label": "Mei", "value": 18 },
              { "label": "Jun", "value": 21 },
              { "label": "Jul", "value": 22 }
            ],
            "xAxisLabel": "Maand",
            "yAxisLabel": "Temperatuur (°C)",
            "hideValues": true
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Steilste stijging vinden",
            "content": "De snelste stijging is waar de lijn het steilst omhoog gaat. Bereken het verschil per stap: mrt→apr = +4, apr→mei = +8, mei→jun = +3, jun→jul = +1. De steilste stijging is april → mei (+8°C).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "line_chart_steepest_rise",
      "variantIndex": 9,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "De ecoloog zoekt waar de lijn het steilst omhoog gaat. Bereken de stijging per stap: maart → april = +4°C, april → mei = +8°C, mei → juni = +3°C, juni → juli = +1°C. De steilste stijging is april → mei (+8°C). Tip: hoe steiler de lijn, hoe sneller de verandering.",
        "solutionSteps": [
          "Bereken de stijging per stap: mrt→apr = 10−6 = +4",
          "Apr→mei = 18−10 = +8",
          "Mei→jun = 21−18 = +3, jun→jul = 22−21 = +1",
          "Grootste stijging: april → mei (+8°C)"
        ],
        "distractorExplanations": {
          "0": "Goed! April → mei had de snelste stijging (+8°C).",
          "1": "Je dacht waarschijnlijk dat maart → april de snelste stijging was. Maar dat was +4°C, terwijl april → mei +8°C was. Onthoud: bereken het verschil per stap.",
          "2": "Je dacht waarschijnlijk dat mei → juni de snelste stijging was. Maar dat was +3°C. April → mei was +8°C. Onthoud: een steile lijn = snelle verandering.",
          "3": "Je dacht waarschijnlijk dat juni → juli de snelste stijging was. Maar dat was slechts +1°C — de lijn is daar bijna vlak. Onthoud: een vlakke lijn = weinig verandering."
        }
      }
    }
  ]
}
